import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';
import { selectUserEmail } from '@lib/core/users/selectors/user';
import { USER_ROLE_KIOSK } from '@lib/core/users/utils/consts';
import { PRODUCT_CATEGORIES } from '@lib/tools/shared/helpers/consts';
import { isProductCategory } from '@lib/tools/shared/helpers/interfaces';

/**
 * @returns the whole user state
 */
export const selectUserState = (state: AppStateType) => state.users.userInstance;

/**
 * @returns the kiosk user's retailer location id. Used for kiosks
 */

export const selectKioskUserRetailerLocationId = createSelector(
  [selectUserState],
  user => user?.data?.retailer_location?.identifier || '',
);

/**
 * @returns the kiosk user's retailer location slug. Used for kiosks
 */
export const selectKioskUserRetailerLocationSlug = createSelector(
  [selectUserState],
  user => user?.data?.retailer_location?.slug || '',
);

/**
 * ! Needs improvement
 * @returns the kiosk user's product category from the email address of the kiosk.
 */

export const selectKioskUserProductCategory = (state: AppStateType) => {
  const email = selectUserEmail(state);
  return (
    Object.values(PRODUCT_CATEGORIES).find(pc => isProductCategory(pc) && email.includes(`-${pc}`)) ||
    PRODUCT_CATEGORIES.PRODUCT_CATEGORY_NONE
  );
};

/**
 * @returns kiosk user retailer slug
 */
export const selectKioskUserRetailerSlug = createSelector(
  [selectUserState],
  user => user?.data?.initial_retailer?.slug || '',
);

/**
 * @returns if user is kiosk admin
 */

export const selectIsUserKioskAdmin = createSelector([selectUserState], user => user?.data?.role === USER_ROLE_KIOSK);
